import { fetchConfigurations } from 'cadenza/config/configuration';
import type { ConditionDto } from 'cadenza/workbook/model/condition-dto';

export async function showConditionEditDialog(condition: ConditionDto) {
  const [{ ConditionEditDialog }] = await Promise.all([
    import('cadenza/workbook/condition-edit-dialog/condition-edit-dialog'),
    fetchConfigurations(['timeslider']),
  ]);
  return new ConditionEditDialog(condition).connectAndShow();
}
